/* Los textos del papel que se firma al recibir algo del pañol (P-311).
 *
 * ── EL DEL CHOFER ES EL DEL ACTA DE PAPEL, PALABRA POR PALABRA ──────────────
 *
 * Copiados de `chofer_elementos.py` (FlotaBot), que los transcribió del papel
 * de Transportes Cantarini SRL y los cotejó el 11/09 contra las ~60 actas
 * escaneadas de 2022 a 2026: el texto no cambió en cuatro años. *«NO se tocan
 * sin que lo pida la empresa: es el texto que el chofer firma»*. Si cambian
 * allá, cambian acá; `textosConstancia.test.js` los fija palabra por palabra
 * para que no se muevan sin querer.
 *
 * ── EL DEL MECÁNICO NO EXISTÍA EN PAPEL ─────────────────────────────────────
 *
 * Las herramientas se entregaban sin papel. Se arma con el mismo molde que el
 * acta del chofer (recibí conforme, a cargo de quien recibe, se descuenta si
 * no se devuelve) cambiando «elementos del camión» por «herramientas» y la
 * unidad por el pañol. Es un borrador para que la empresa lo apruebe o lo
 * cambie: hasta entonces, es el que sale.
 */

export const ACTA_CHOFER = {
  titulo: "Acta de entrega de elementos",
  intro:
    "Mediante la presente se notifica que el chofer {persona} recibió conforme " +
    "los elementos del camión que se detallan abajo. Los mismos serán " +
    "responsabilidad del chofer en cuestión y se procederá a ser descontadas al " +
    "valor actual en caso de no ser devueltas cuando la empresa lo requiera así.",
  parrafos: [
    "Es importante aclarar que los elementos se encuentran EXCLUSIVAMENTE a cargo " +
    "del chofer en cuestión y ante cualquier cambio en la unidad tractora u otro " +
    "inconveniente, es el chofer quien debe hacerse responsable de las mismas, ya " +
    "sea devolviéndoselas a personal de taller o llevándoselas consigo a la nueva " +
    "unidad asignada.",
    "Bajo ningún punto de vista el chofer puede bajar los elementos de la " +
    "unidad en lugares ajenos a la empresa.",
  ],
};

export const ACTA_MECANICO = {
  titulo: "Constancia de entrega de herramientas",
  intro:
    "Mediante la presente se notifica que {persona} recibió conforme del pañol " +
    "de la empresa las herramientas que se detallan abajo. Las mismas serán " +
    "responsabilidad de quien las recibe y se procederá a ser descontadas al " +
    "valor actual en caso de no ser devueltas cuando la empresa lo requiera así.",
  parrafos: [
    "Ante la rotura, la pérdida o un cambio de puesto, quien las recibió debe " +
    "informarlo al pañol y devolverlas.",
  ],
};

export const actaPara = (destinatario) =>
  (destinatario === "chofer" ? ACTA_CHOFER : ACTA_MECANICO);

/* La cabecera del papel, la misma del acta impresa. */
export const EMPRESA = {
  marca: "TRANSPORTES CANTARINI",
  bajada: "S.R.L.",
  direcciones: [
    "Casa Central: Combate de Montevideo 834 (V9420DQR) · Río Grande, Tierra del Fuego · Tel. 02964-4313225",
    "Deleg. Buenos Aires: Federico Ozanam 3855 (Ruta 202 y Baltasar Gracián), B1611EJS Don Torcuato · Tel./Fax (54-11) 4513-2266",
  ],
};

/* La introducción partida en tres para poner el nombre en negrita sin
   romper el texto legal. */
export function introPartida(destinatario, persona) {
  const [antes, despues] = actaPara(destinatario).intro.split("{persona}");
  return { antes, persona: String(persona || "").trim() || "____________", despues };
}
